<template>

  <div class="container">
    <navBar/>

    <transition :name="routerTransition">

      <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
        <div
          class="content-area__heading"
          :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
          <h2 class="mb-1">Vista Previa</h2>
        </div>

        <!-- BREADCRUMB -->
        <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

      </div>
    </transition>

    <div class="vx-row" v-if="document.attributes">
      <div class="vx-col w-full md:w-full lg:w-2/3 mb-5">
        <ReactPdfViewer
          class="background-fb card-p ovh"
          :pdf="api_url + document.attributes.download_link"
          :height="pdfViewerHeight"
        ></ReactPdfViewer>
      </div>

      <div class="vx-col sm:w-full md:w-full lg:w-1/3">
        <vs-card >
          <div class="p-3">
            <h3 class="pb-2"> Resumen del documento</h3>

            <span class="pb-3"> <b>Nombre del documento:</b> <span> {{ this.document.attributes.document_name }}</span></span>
              <div class="py-2 pb-4">
                 <a :href="downloadLink" target="_blank">Descargar documento</a>
              </div>

            <div v-if="!rejectEnable && simpleSignatureFeature && allowSignatureTypes.includes('VERIFICAMEX') && (identityProviders.includes('VERIFICAMEX') || identityProviders.includes('LOCAL'))">
              <h3 class="pb-2 mt-5">Método Firma Simple</h3>
            </div>
            <div v-if="!rejectEnable && simpleSignatureFeature && allowSignatureTypes.includes('VERIFICAMEX') && identityProviders.includes('VERIFICAMEX')">
              <p class="mb-4">Si no cuentas con e.firma o FIREL puedes firmar con tu identidad usando una INE.</p>
              <vx-tooltip class="" text="Firma mediante tu Identidad usando tu INE" position="top">
                <vs-button class="w-100 mb-4" color="primary" type="border" @click="toggleTab(9)">Firma Electrónica con identidad</vs-button>
              </vx-tooltip>
            </div>
            <div v-if="!rejectEnable && simpleSignatureFeature && allowSignatureTypes.includes('VERIFICAMEX') && identityProviders.includes('LOCAL')">
              <p class="mb-4">Firma con un vídeo y validando tu teléfono (recomendado para extranjeros).</p>
              <vx-tooltip class="" text="Firma simple (para extranjeros)" position="top">
                <vs-button class="w-100 mb-4" color="primary" type="border" @click="toggleTab(10)">Firma Electrónica Simple</vs-button>
              </vx-tooltip>
            </div>
            <div v-if="!rejectEnable && simpleSignatureFeature && allowSignatureTypes.includes('VERIFICAMEX') && identityProviders.includes('VERIFICAMEX') && identityProviders.includes('LOCAL')">
              <a target="_blank" href="https://blog.verificamex.com/diferencia-entre-firma-electronica-simple-con-identidad-y-firma-electronica-simple"> <feather-icon icon="HelpCircleIcon" svgClasses="w-4 h-4" /> Conocer las diferencias</a>
            </div>

            <div v-if="!rejectEnable && isAdvancedSignEnable">
              <h3 class="pb-2 mt-5">Método de Firma Avanzada</h3>
              <p class="mb-4">Selecciona el tipo de certificado:</p>
              <vs-button v-if="allowSignatureTypes.includes('EFIRMA')" class="w-100 mb-4" color="primary" type="border" @click="toggleTab(2)">Firmar con e.firma (SAT)</vs-button>
              <vs-button v-if="['FIREL', 'TEPJF'].every(item => allowSignatureTypes.includes(item))" class="w-100 mb-4" color="primary" type="border" @click="toggleTab(8)">Firmar con FIREL (PJF)</vs-button>
            </div>

            <div v-if="!rejectEnable">
              <h3 class="pb-2 mt-5 mb-4">No quiero firmar</h3>
              <p class="mb-4">No estoy de acuerdo con lo descrito en el documento, deseo rechazar el la firma.</p>
              <vs-button :color="rejectEnable ? 'warning' : 'danger'" :type="rejectEnable ? undefined : 'border'" @click="rejectEnable = !rejectEnable">
                {{ rejectEnable ? 'Cancelar rechazo' : 'Rechazar documento' }}
              </vs-button>
            </div>
          </div>
        </vs-card>

        <vs-card v-if="rejectEnable">

          <div class="p-3">
            <h4 class="pb-2">Rechazar documento</h4>
            <div>
              <span class="pb-3">No estoy de acuerdo con la firma de este documento.</span>
            </div>
            <div class="pb-3">
              <p >Exposición de motivos:</p>
            </div>

            <quill-editor v-model="reject_motive" :options="editorOptions"></quill-editor>

          <br>
          <div>
            <vs-button :disabled="isSubmitted" ref="loadableButton" id="button-with-loading" class="vs-con-loading__container mr-3" @click="submitReject" color="primary">
              Rechazar
            </vs-button>
            <vs-button :color="rejectEnable ? 'warning' : 'danger'" :type="rejectEnable ? undefined : 'border'" @click="rejectEnable = !rejectEnable">
              {{ rejectEnable ? 'Cancelar rechazo' : 'Rechazar documento' }}
            </vs-button>
          </div>
          </div>
        </vs-card>

      </div>

    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import router from "@/router";
import {API_URL} from "@/config/app";
import navBar from "@/layouts/components/navbar/NavBarHorizontalLayout.vue";
import {ReactInVue} from 'vuera';
import ReactPdfViewer from "../../../../components/viewer-pdf/ReactPdfViewer";
import themeConfig from '@/../themeConfig.js'

export default {
  name: "SignDocument",
  props: ['toggleTab'],
  components: {
    quillEditor,
    navBar,
    'ReactPdfViewer': ReactInVue(ReactPdfViewer)
  },
  data () {
    return {
      isSubmitted: false,
      rejectEnable: false,
      simpleSignatureFeature: false,
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline','strike', 'blockquote'],
            [{'list': 'ordered'}, {'list': 'bullet'}, { 'color': ['red', 'green', 'blue', 'orange', 'violet', '#d0d1d2', 'black'] }],
          ],
        }
      },
      reject_motive: "",
      uuid: "",
      document: {},
      allowSignatureTypes: [],
      identityProviders: [],
      api_url: API_URL,
      windowWidth: window.innerWidth,
      routerTransition  : themeConfig.routerTransition || 'none',
    }
  },
  computed: {
    downloadLink() {
      if (this.document && this.document.attributes) {
        return this.api_url + this.document.attributes.download_link;
      }
      return '';
    },
    pdfViewerHeight() {
      return this.windowWidth < 992 ? '40vh' : '80vh';
    },
    isAdvancedSignEnable() {
      return ['FIREL', 'TEPJF'].every(item => this.allowSignatureTypes.includes(item)) || this.allowSignatureTypes.includes('EFIRMA')
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    submitReject() {
      this.$store.dispatch("alert/clear", {}, {root:true});
      if (!this.uuid || !this.reject_motive) {
        this.$store.dispatch("alert/error", "Ingrese los datos requeridos");
        return;
      }
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#button-with-loading",
        scale: 0.45
      });
      this.isSubmitted = true;
      this.$store.dispatch("document/reject", {
        uuid: this.uuid,
        motive: this.reject_motive
      }).then(
        () => {
          this.toggleTab(5);
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          this.isSubmitted = false;
        },
        () => {
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          this.isSubmitted = false;
        }
      )
    },
  },
  created() {
    let uuid = this.$route.params.uuid
    if (uuid) {
      this.uuid = uuid;
    } else {
      router.push("/");
    }

    this.$store.dispatch("document/getDocumentFromSignature", {uuid: this.uuid})
      .then(
        document => {
          this.document = document;
          console.log(this.document);
          this.simpleSignatureFeature = this.document.attributes.plan_features.includes("can_simple_signature")
          if (this.document.attributes.config.allow_type_signatures.length) {
            this.allowSignatureTypes = this.document.attributes.config.allow_type_signatures;
          } else {
            this.allowSignatureTypes = [
              "VERIFICAMEX", 'EFIRMA', 'FIREL', 'TEPJF'
            ];
          }
          if (this.document.attributes.config.identity_providers && this.document.attributes.config.identity_providers.length) {
            this.identityProviders = this.document.attributes.config.identity_providers;
          } else {
            this.identityProviders = [
              "VERIFICAMEX"
            ];
          }
          if (this.document.attributes.sign_status === 3 || this.document.attributes.signature_status === 'SIGNED') {
            this.toggleTab(6);
            return;
          }
          if (this.document.attributes.sign_status === 4) {
            this.toggleTab(4);
          }
          if (
            this.document.attributes.sign_status !== 3
            && this.document.attributes.sign_status !== 4
            && this.document.attributes.signature_flow_id
          ) {
            if (this.document.attributes.signature_flow_status === 'ERROR') {
              return;
            }
            router.push({name: "page-signature-flow", params: {uuid: this.uuid, signatureFlowId: this.document.attributes.signature_flow_id}})
          }
        },
        () => {
          this.toggleTab(4);
        }
      )
  }
}
</script>

<style scoped lang="scss">
 .ovh{
   overflow: hidden;
 }
</style>
